export enum ReimbursementType {
  Gym = 1,
  Other = 2
}

export enum ReimbursementStatus {
  Pending = 1,
  Approved = 2,
  Denied = 3,
  ApprovedNeedsFinalApproval = 4
}

export interface ReimbursementModel {
  id: number;
  userID: number;
  employeeName: string;
  campusID?: number;
  campusName?: string;
  reimbursementTypeID: number;
  reimbursementType: string;
  expenseDate: string;
  merchant: string;
  description: string;
  requestedAmount: number;
  approvedAmount?: number;
  statusID: number;
  status: string;
  submittedDate: string;
  confirmedDate: string;
  reviewedDate?: string;
  reviewedBy?: string;
  denialReason?: string;
  payPeriodID?: number;
  payPeriodStartDate?: string;
  payPeriodEndDate?: string;
  receiptAttachmentID: number;
  receiptFileName: string;
}

export interface ReimbursementSubmissionModel {
  reimbursementTypeID: number;
  expenseDate: string;
  merchant: string;
  description: string;
  requestedAmount: number;
  confirmed: boolean;
  receipt?: File;
}

export interface ReimbursementCampusModel {
  id: number;
  programName: string;
}

export interface ReimbursementManagementFilters {
  statusID?: number;
  employee?: string;
  campusID?: number;
  minimumAmount?: number;
  maximumAmount?: number;
  submittedFrom?: string;
  submittedThrough?: string;
  payPeriodID?: number;
}
